<template>
  <div v-if="faqs.length">
    <div class="header-2">
      <div class="page-header header-filter">
        <div 
          :style="{backgroundImage: 'url(' + options.defaultAirport.backgroundImageUrl + ')'}"
          class="page-header-image" 
          style="background-image: url('img/bg-default.png')"/>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title m-0">Frequently Asked Questions</h1>
              </div>
              <div class="col-md-6 ml-auto mr-auto">
                <div 
                  class="card card-raised card-form-horizontal card-plain m-0" 
                  data-background-color>
                  <div class="card-body">
                    <form>
                      <div class="row">
                        <div class="col-md-12">
                          <fg-input 
                            :value="search" 
                            addon-left-icon="bx bx-search"
                            placeholder="Search"
                            @input="search=$event.target.value"/>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center my-4">
        <div class="col-md-10">
          <collapse
            :active-index="0"
            :multiple-active="false">
            <collapse-item 
              v-for="(faq, index) in filters"
              :key="index"
              :title="faq.question">
              <template v-slot:title>
                {{ faq.question }}
              </template>
              <template v-slot:icon>
                <i class="bx bx-plus mr-1" />
                <i class="bx bx-minus mr-1" />
              </template>
              <div v-html="faq.answer" />
            </collapse-item>
          </collapse>
          <h4 
            v-if="!filters.length && !loading" 
            class="text-center">No FAQs</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import { mapState, mapMutations } from 'vuex';
  import { Button, Card, Collapse, CollapseItem, FormGroupInput } from '@/components';

  export default {
    components: {
      Card,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      Collapse,
      CollapseItem,
    },
    data() {
      return {
        faqs: [],
        search: '',
        filters: []
      };
    },
    computed: {
      ...mapState([
        'loading',
        'options'
      ])
    },
    watch: {
      search() {
        const filters = [];
        this.faqs.forEach(faq => {
          if (faq.question.toLowerCase().includes(this.search.toLowerCase()) || faq.answer.toLowerCase().includes(this.search.toLowerCase())) {
            filters.push(faq);
          }
        });
        this.filters = filters;
      }
    },
    created() {
      this.getFaqs();
    },
    methods: {
      ...mapMutations([
        'setLoading'
      ]),
      getFaqs() {
        axios.get('website/faq').then(res => {
          const { data } = res;
          console.log('website/faq: ', data);
          this.faqs = data;
          this.filters = Object.assign([], this.faqs);
          this.setLoading(false);
        })
      }
    }
  }
</script>
<style lang='scss' scoped>
  .page-header {
    min-height: 30vh !important;

    .page-header-image {
      background-position: center center !important;
    }

    .container {
      text-align: left !important;

      .title {
        @media (max-width: 771px) {
          font-size: 2.25em;
        }
      }
    }
  }
  ::v-deep .card-collapse {
    .card {
      margin-bottom: 8px;

      .card-header {
        a {
          .bx {
            float: left;
          }
          .bx-plus {
            display: inline-block;
          }
          .bx-minus {
            display: none;
          }
        }
        a[aria-expanded="true"] {
          .bx {
            float: left;
          }
          .bx-plus {
            display: none;
          }
          .bx-minus {
            display: inline-block;
          }
        }
      }
    }
  }
</style>
